/**
 * 直播统计
 */
// 点击直播营销页
export const STATISTIC_LIVEMANAGE_PURCHASE = 'livemanage_purchase'
